module.exports = __webpack_public_path__ + "static/article-image-third-cda3b19ba4232814b6dbaa40ad18a9b7.jpg";